import React from 'react';
import axios from "axios";
import {LOAD_FICHE_HISTORY, LOAD_SENDED_DOCUMENTS} from "../../../../api/Api";
import {useParams} from "react-router-dom";
import moment from "moment";

export default function HistoryPage(){


    const {id} = useParams();

    const [isLoadingHistory, setIsLoadingHistory] = React.useState(false)
    const [history, setHistory] = React.useState(false)


    async function loadHistory() {

        setIsLoadingHistory(true)

        try {

            const response = await axios.get(
                `${LOAD_FICHE_HISTORY}/${id}`
            );

            setHistory(response.data)

        } catch (e) {

        } finally {
            setIsLoadingHistory(false)
        }

    }


    const cieHistory = React.useMemo(()=>{
        if(history)
            return history.filter(item=>item.properties.societe == 'CIE');

        return [];
    },[history]);

    const sodeciHistory = React.useMemo(()=>{
        if(history)
            return history.filter(item=>item.properties.societe == 'SODECI');

        return [];
    },[history]);



    React.useEffect(() => {
        loadHistory()
    }, [])


    return (
        <div>
            <div className="h3 text-primary">
                Historique de la demande
            </div>

            <div className={'row'}>



                {
                    cieHistory.length > 0 && (
                        <div className={'col'}>

                            <div>
                                CIE
                            </div>

                            {
                                cieHistory.map(
                                    (historyItem,index) => {
                                        return (
                                            <div>

                                                <div key={index} className="card my-3">
                                                    <div className="card-body">
                                                        <div dangerouslySetInnerHTML={{ __html: historyItem.properties.customLog?.customerLog }}></div>
                                                    </div>
                                                </div>

                                                <div className="small font-weight-bold text-right">
                                                    {moment(historyItem.created_at).format('DD/MM/Y kk:mm')}
                                                </div>

                                            </div>
                                        )
                                    }
                                )
                            }

                        </div>
                    )
                }

                {
                    sodeciHistory.length > 0 && (
                        <div className={'col'}>

                            <div>
                                SODECI
                            </div>

                            {
                                sodeciHistory.map(
                                    (historyItem,index) => {
                                        return (
                                            <div>

                                                <div key={index} className="card my-3">
                                                    <div className="card-body">
                                                        <div dangerouslySetInnerHTML={{ __html: historyItem.properties.customLog?.customerLog }}></div>
                                                    </div>
                                                </div>

                                                <div className="small font-weight-bold text-right">
                                                    {moment(historyItem.created_at).format('DD/MM/Y kk:mm')}
                                                </div>

                                            </div>
                                        )
                                    }
                                )
                            }

                        </div>
                    )
                }

            </div>

            <div>


            </div>

        </div>
    )
}